module.exports = __webpack_public_path__ + "static/instagram-icon-footer-c7de41ee12922b06dd9c2d46e2fc0183.png";